import { Navigate } from 'react-router-dom';

export default function ExpensesDebitPage() {
  return <Navigate to="/transactions" replace />;
}
